import React from 'react';
import { Filtering, QBox, QSelect, QSelectItem } from '@qualio/ui-components';
import { VersionedTemplateStatusValues } from '../../../types';

type StatusFilterDefinitions = {
  status: Filtering.FilterDefinition & { schema: Filtering.schemas.NullableFilterSchema<string> };
};

export type StatusFilterProps = {
  filterOptions: QSelectItem<string, string>[];
  setVersionedStatusFilter: React.Dispatch<React.SetStateAction<VersionedTemplateStatusValues>>;
};

export const StatusFilter = ({ filterOptions, setVersionedStatusFilter }: StatusFilterProps) => {
  const filtering = Filtering.useFiltering<StatusFilterDefinitions>();

  const initialValue = filtering.filters.status?.value;
  if (initialValue) {
    setVersionedStatusFilter(initialValue as VersionedTemplateStatusValues);
  }

  const onStatusChange = (status: QSelectItem | null) => {
    if (status) {
      filtering.setFilters({
        status: status.value,
      });
      setVersionedStatusFilter(status.value as VersionedTemplateStatusValues);
    }
  };

  return (
    <QBox w="300px" data-cy="event-templates-filter">
      <QSelect
        size="sm"
        options={filterOptions}
        onChange={onStatusChange}
        value={filtering.filters.status?.value}
        aria-label="Template status"
        inputId="status-filter-input"
      ></QSelect>
    </QBox>
  );
};
